import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32f9f8ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component dicomoption" }
const _hoisted_2 = { class: "option_wrapper" }
const _hoisted_3 = { class: "score_box" }
const _hoisted_4 = {
  key: 0,
  class: "loading_box"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-area" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "spinner" })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title_text" }, "Score", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inactive_box" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Complete score", -1))
const _hoisted_10 = { class: "score_input_box" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "%", -1))
const _hoisted_12 = { class: "save_btn_box" }
const _hoisted_13 = { class: "dicom_box" }
const _hoisted_14 = {
  key: 0,
  class: "loading_box"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-area" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "spinner" })
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "gray__box option_box" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inactive_box" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title_text" }, "Option", -1))
const _hoisted_20 = { class: "option" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Window Center", -1))
const _hoisted_22 = { class: "option" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Window Width", -1))
const _hoisted_24 = {
  key: 0,
  class: "option checkbox_container container_box"
}
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<div class=\"checkbox\" data-v-32f9f8ba><svg class=\"icon\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-32f9f8ba><mask id=\"mask0_334_286\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"16\" height=\"16\" data-v-32f9f8ba><rect width=\"16\" height=\"16\" fill=\"#D9D9D9\" data-v-32f9f8ba></rect></mask><g mask=\"url(#mask0_334_286)\" data-v-32f9f8ba><path d=\"M6.36686 12L2.56686 8.20001L3.51686 7.25001L6.36686 10.1L12.4835 3.98334L13.4335 4.93334L6.36686 12Z\" data-v-32f9f8ba></path></g></svg></div><h3 data-v-32f9f8ba>Mask</h3>", 2)
const _hoisted_27 = [
  _hoisted_25
]
const _hoisted_28 = /*#__PURE__*/_createStaticVNode("<div class=\"checkbox\" data-v-32f9f8ba><svg class=\"icon\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-32f9f8ba><mask id=\"mask0_334_286\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"16\" height=\"16\" data-v-32f9f8ba><rect width=\"16\" height=\"16\" fill=\"#D9D9D9\" data-v-32f9f8ba></rect></mask><g mask=\"url(#mask0_334_286)\" data-v-32f9f8ba><path d=\"M6.36686 12L2.56686 8.20001L3.51686 7.25001L6.36686 10.1L12.4835 3.98334L13.4335 4.93334L6.36686 12Z\" data-v-32f9f8ba></path></g></svg></div><h3 data-v-32f9f8ba>Heat map</h3>", 2)
const _hoisted_30 = [
  _hoisted_28
]
const _hoisted_31 = /*#__PURE__*/_createStaticVNode("<div class=\"checkbox\" data-v-32f9f8ba><svg class=\"icon\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-32f9f8ba><mask id=\"mask0_334_286\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"16\" height=\"16\" data-v-32f9f8ba><rect width=\"16\" height=\"16\" fill=\"#D9D9D9\" data-v-32f9f8ba></rect></mask><g mask=\"url(#mask0_334_286)\" data-v-32f9f8ba><path d=\"M6.36686 12L2.56686 8.20001L3.51686 7.25001L6.36686 10.1L12.4835 3.98334L13.4335 4.93334L6.36686 12Z\" data-v-32f9f8ba></path></g></svg></div><h3 data-v-32f9f8ba>Probability map</h3>", 2)
const _hoisted_33 = [
  _hoisted_31
]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inactive_box mask" }, null, -1))
const _hoisted_35 = { class: "option" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Tube threshold", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inactive_box heatmap" }, null, -1))
const _hoisted_38 = { class: "option container_box" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "Select Heat map")
], -1))
const _hoisted_40 = { class: "combobox_container" }
const _hoisted_41 = { class: "selected option" }
const _hoisted_42 = { class: "combobox_option" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("mask", {
  id: "mask0_108_164",
  style: {"mask-type":"alpha"},
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "0",
  width: "24",
  height: "24"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    width: "24",
    height: "24",
    fill: "#ffffff"
  })
], -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { mask: "url(#mask0_108_164)" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "M12 15.4L6 9.4L7.4 8L12 12.6L16.6 8L18 9.4L12 15.4Z" })
], -1))
const _hoisted_46 = [
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = { class: "option" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Image weight", -1))
const _hoisted_49 = { class: "reset_btn_box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_slider = _resolveComponent("vue-slider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.imageLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["complete_box gray__box", {'inactive': _ctx.savedCompleteScore || Object.keys(_ctx.dicomFile).length === 0 || _ctx.dicomFile.is_reviewed}])
        }, [
          _hoisted_7,
          _createElementVNode("div", null, [
            _hoisted_8,
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "input__box",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.completeScore) = $event)),
                min: "0",
                max: "100",
                onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.validateScore && _ctx.validateScore(...args))),
                placeholder: "0"
              }, null, 544), [
                [_vModelText, _ctx.completeScore]
              ]),
              _hoisted_11
            ]),
            _createVNode(_component_vue_slider, {
              modelValue: _ctx.completeScore,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.completeScore) = $event)),
              marks: [0,100],
              min: 0,
              max: 100,
              tooltip: 'none',
              lazy: true
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            (!_ctx.dicomFile.is_reviewed)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: _normalizeClass(["btn__default gray save_btn", {'inactive': _ctx.savedCompleteScore || Object.keys(_ctx.dicomFile).length === 0 || _ctx.dicomFile.is_reviewed || _ctx.completeScore?.toString() == '' || _ctx.completeScore?.toString() == undefined}]),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.saveScore()))
                }, "Confirm", 2))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn__default gray save_btn",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.resetScore()))
                }, "Reset"))
          ])
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_13, [
        (_ctx.showLoadingBox || _ctx.scoreLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", {
            class: _normalizeClass(["option_wrap", {'inactive': Object.keys(_ctx.dicomFile).length === 0}])
          }, [
            _hoisted_18,
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", null, [
                _hoisted_21,
                _createElementVNode("h3", null, _toDisplayString(_ctx.wc), 1)
              ]),
              _createVNode(_component_vue_slider, {
                modelValue: _ctx.wc,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.wc) = $event)),
                marks: [_ctx.windowCenterMin, _ctx.windowCenterMax],
                min: _ctx.windowCenterMin,
                max: _ctx.windowCenterMax,
                tooltip: 'none',
                lazy: false,
                onChange: _ctx.switchViewer
              }, null, 8, ["modelValue", "marks", "min", "max", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", null, [
                _hoisted_23,
                _createElementVNode("h3", null, _toDisplayString(_ctx.ww), 1)
              ]),
              _createVNode(_component_vue_slider, {
                modelValue: _ctx.ww,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ww) = $event)),
                marks: [_ctx.windowWidthMin, _ctx.windowWidthMax],
                min: _ctx.windowWidthMin,
                max: _ctx.windowWidthMax,
                tooltip: 'none',
                lazy: false,
                onChange: _ctx.switchViewer
              }, null, 8, ["modelValue", "marks", "min", "max", "onChange"])
            ]),
            (_ctx.withCAD)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["mask check_option", { 'active': _ctx.maskCheck }]),
                    onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.toggleMaskCheck(!_ctx.maskCheck); _ctx.switchViewer()})
                  }, _hoisted_27, 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["heat_map check_option", { 'active': _ctx.heatMapCheck }]),
                    onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.toggleHeatMapCheck(!_ctx.heatMapCheck); _ctx.switchViewer()})
                  }, _hoisted_30, 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["probability check_option", { 'active': _ctx.probabilityCheck }]),
                    onClick: _cache[9] || (_cache[9] = ($event: any) => {_ctx.toggleProbabilityCheck(!_ctx.probabilityCheck); _ctx.switchViewer()})
                  }, _hoisted_33, 2)
                ]))
              : _createCommentVNode("", true),
            (_ctx.withCAD)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["option_container", {'inactive': !_ctx.maskCheck}])
                }, [
                  _hoisted_34,
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", null, [
                      _hoisted_36,
                      _createElementVNode("h3", null, _toDisplayString(_ctx.tube), 1)
                    ]),
                    _createVNode(_component_vue_slider, {
                      modelValue: _ctx.tube,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.tube) = $event)),
                      marks: _ctx.floatMask,
                      interval: 0.01,
                      min: 0.01,
                      max: 1,
                      tooltip: 'none',
                      lazy: false,
                      onChange: _ctx.switchViewer
                    }, null, 8, ["modelValue", "marks", "onChange"])
                  ])
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.withCAD)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: _normalizeClass(["option_container", {'inactive': !_ctx.heatMapCheck}])
                }, [
                  _hoisted_37,
                  _createElementVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["combobox", { 'active': _ctx.comboboxOpen }]),
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.toggleCombobox()))
                      }, [
                        _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.comboboxSelected), 1),
                        _createElementVNode("div", _hoisted_42, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comboboxOption, (option, idx) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: option,
                              class: _normalizeClass(["option", {'selected': option.selected}]),
                              onClick: ($event: any) => {_ctx.setHeatmapOption(idx); ; _ctx.switchViewer();}
                            }, _toDisplayString(option.name), 11, _hoisted_43))
                          }), 128))
                        ])
                      ], 2),
                      (_openBlock(), _createElementBlock("svg", {
                        class: _normalizeClass(["arrow_icon", { 'active': _ctx.comboboxOpen }]),
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, _hoisted_46, 2))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", null, [
                      _hoisted_48,
                      _createElementVNode("h3", null, _toDisplayString(_ctx.iw), 1)
                    ]),
                    _createVNode(_component_vue_slider, {
                      modelValue: _ctx.iw,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.iw) = $event)),
                      marks: _ctx.floatMask,
                      interval: 0.01,
                      min: 0.01,
                      max: 1,
                      tooltip: 'none',
                      lazy: false,
                      onChange: _ctx.switchViewer
                    }, null, 8, ["modelValue", "marks", "onChange"])
                  ])
                ], 2))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("button", {
              class: _normalizeClass(["reset_btn btn__default gray", {'inactive': Object.keys(_ctx.dicomFile).length === 0 }]),
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.initializeOptions()))
            }, "Reset", 2)
          ])
        ])
      ])
    ])
  ]))
}